/*********************************************************
 *                  Carrier deposit-area edit Ctrl
 ********************************************************/


"use strict";

angular.module("manager")
	.controller("DepositAreaEditCtrl", [
		"$scope", "Utils", "$location", "DepositAreaService", "toastr", "editMode", "selectedDepositArea",
		function ($scope, Utils, $location, DepositAreaService, toastr, editMode, selectedDepositArea) {

		/**
			 * INIT
			 */
		$scope.data = {
			selectedDepositArea: selectedDepositArea == null ? null : selectedDepositArea.data,
			typeList: ["PRIVE", "PUBLIQUE"],
			editMode: editMode
		};



		/**
			 * Valide l'ajout d'une zone de dépôt
			 * @param depositArea
			 */
		$scope.addDepositArea = function (depositArea) {
			DepositAreaService.addDepositArea(depositArea)
				.then(() => {
					toastr.success("Zone de dépot ajouté");
					$location.url("/manager/deposit-area");
				})
				.catch(function (err) {
					toastr.error(Utils.makeErrorMessage(err.data, "Erreur lors de l'ajout de la zone dépôt."));
				});
		};

		/**
			 * Valide la modification d'une zone de dépôt
			 * @param depositArea
			 */
		$scope.editDepositArea = function(depositArea) {
			DepositAreaService.editDepositArea(depositArea)
				.success(() => {
					toastr.success("Zone de dépôt modifié.");
					$location.url("/manager/deposit-area");
				})
				.catch(function (err) {
					toastr.error(Utils.makeErrorMessage(err.data, "Erreur lors de la modification de la zone dépôt."));
				});
		};


	}]
	);